import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const el = document.getElementById("hero-cta");
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, []);
  return <AnimatePresence data-id="element-36" data-mp="bpzp326st0uj">
      {visible && <motion.div initial={{
      y: 96,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 96,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:pb-5" data-id="element-37" data-mp="boyawouhjy8l">
          <a href={CHECKOUT_URL} className="mx-auto flex max-w-md animate-shake items-center justify-center gap-2 rounded-2xl bg-cta px-5 py-4 font-display text-[17px] font-black uppercase tracking-tight text-white shadow-[0_6px_0_0_#0b7a37,0_14px_30px_-6px_rgba(6,20,46,0.55)] transition-colors duration-150 ease-out hover:bg-cta-dark focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-gold" data-id="element-38" data-mp="2b4tbkg5sixek">
            Get it now for only $27
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-39" data-mp="1weuc8a2i1fxi" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}